import { StickyTableFooter } from "@design-system/StickyTableFooter/StickyTableFooter";
import stickyFooterStyles from "@design-system/StickyTableFooter/StickyTableFooter.module.scss";
import classNames from "classnames";
import styles from "./ViewTableStickyFooter.module.scss";

interface Props {
    children: React.ReactNode;
    className?: string;
}

export const ViewTableStickyFooter: React.FC<Props> = ({
    children,
    className,
}) => (
    <StickyTableFooter
        className={classNames(styles.stickyFooter, className)}
        borderless
    >
        <div className={stickyFooterStyles.row}>
            <div className={stickyFooterStyles.rowContent}>{children}</div>
        </div>
    </StickyTableFooter>
);
